export const activeLinksConstants = {
    ACTIVE_LINKS_SET: "ACTIVE_LINKS_SET",
    ACTIVE_LINKS_CLEAR: "ACTIVE_LINKS_CLEAR"
  };
  